module.exports = __webpack_public_path__ + "static/media/logo-sm.e82fa97f.webp";